module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pl-dialog', [_c('header', {
    staticClass: "text-gray-700 flex justify-between py-3 border-b px-7 items-center text-lg font-semibold"
  }, [_c('h6', [_vm._v("\n      Sync Assessment Data to\n      "), _c('span', {
    staticClass: "capitalize"
  }, [_vm._v(_vm._s(_vm.selectedIntegration))])]), _vm._v(" "), _c('i', {
    staticClass: "fas fa-times text-gray-600 cursor-pointer hover:text-gray-900",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  })]), _vm._v(" "), (_vm.loading) ? _c('div', [_c('div', {
    staticClass: "flex justify-center my-56"
  }, [_c('pl-spinner', {
    staticClass: "w-24 h-24"
  })], 1)]) : _c('div', {
    staticClass: "py-5 flex-grow overflow-y-auto"
  }, [_c('div', {
    staticClass: "py-8 bg-gray-50"
  }, [_c('header', {
    staticClass: "flex justify-center items-center mb-4"
  }, [_c('img', {
    staticClass: "w-12 h-12 mx-5",
    attrs: {
      "src": "/static/logos/parlay_logo.svg",
      "alt": "Parlay"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa-solid fa-arrow-right-long text-gray-500 text-base"
  }), _vm._v(" "), _c('img', {
    staticClass: "w-11 h-11 mr-2 mx-5",
    attrs: {
      "src": _vm.logo,
      "alt": "integration-logo"
    }
  })]), _vm._v(" "), (_vm.selectedIntegration) ? _c('h5', {
    staticClass: "text-center text-base font-semibold text-gray-800"
  }, [_vm._v("\n        Sync Parlay to\n        "), _c('span', {
    staticClass: "capitalize text-gray-800"
  }, [_vm._v(_vm._s(_vm.selectedIntegration))])]) : _vm._e()]), _vm._v(" "), _c('div', [_c('ul', {
    staticClass: "px-24 mt-7"
  }, _vm._l((_vm.sync_payload), function(criteria, index) {
    return _c('li', {
      key: index,
      staticClass: "flex justify-between items-center py-2"
    }, [_c('div', [_c('p', {
      staticClass: "font-medium"
    }, [_vm._v(_vm._s(criteria.title))])]), _vm._v(" "), _c('div', {
      staticClass: "flex items-center justify-center"
    }, [_c('pl-input', {
      staticClass: "w-auto",
      attrs: {
        "centeredText": true,
        "type": "integer",
        "error": !_vm.validPercentages
      },
      model: {
        value: (criteria.value),
        callback: function($$v) {
          _vm.$set(criteria, "value", $$v)
        },
        expression: "criteria.value"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "ml-3"
    }, [_vm._v("%")])], 1)])
  }), 0), _vm._v(" "), (_vm.edLink) ? _c('div', {
    staticClass: "flex justify-center pt-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sync_feedback),
      expression: "sync_feedback"
    }],
    staticClass: "mr-2.5 cursor-pointer",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.sync_feedback) ? _vm._i(_vm.sync_feedback, null) > -1 : (_vm.sync_feedback)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.sync_feedback,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.sync_feedback = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.sync_feedback = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.sync_feedback = $$c
        }
      }
    }
  }), _vm._v("\n        Also sync written feedback\n      ")]) : _vm._e()])]), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "flex justify-center items-center my-5"
  }, [_c('button', {
    staticClass: "bg-gray-100 hover:bg-gray-200 px-6 py-2 mr-4 rounded",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n      Cancel\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "px-6 py-2 bg-primary rounded text-white",
    on: {
      "click": function($event) {
        return _vm.syncAssessment()
      }
    }
  }, [_c('span', {
    staticClass: "flex items-center"
  }, [_c('span', [_vm._v("Sync Data")]), _vm._v(" "), (_vm.isSync === true) ? _c('svg', {
    staticClass: "ml-2 w-4 h-4 text-white animate-spin",
    attrs: {
      "role": "status",
      "viewBox": "0 0 100 101",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
      "fill": "#E5E7EB"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
      "fill": "currentColor"
    }
  })]) : _vm._e()])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-17e4a58a!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/modals/syncAssessmentDataModal.vue
// module id = 991
// module chunks = 61